export const FORCE_STOP_LOADING = 'FORCE_STOP_LOADING';

export const SunriseRoles = {
  SUPERVISOR: 'ROLE_SR_NB_SUP',
  ADMIN: 'ROLE_SR_ADMIN',
  COMPLIANCE: 'ROLE_SR_NB_COMP',
  KYC: 'ROLE_SR_KYCManual',
};

export const YN_IND = {
  YES: 'Y',
  NO: 'N',
  UN: '*',
};

export const PRODUCT_CODE_LOV = {
  UL_AFFLUENT: 'BU10A1',
  UL_2022_STD: 'BU12A1',
  UL_2022_SPC: 'BU13A1',
};

export const SHOW_POLICY_ALLOCATION_BY_PLAN_CODE = ['IL03A1', 'IL04A1'];

export const DEFAULT_ALERT = { type: 'success', message: '' };

export const ENUM_SUBMIT_TYPE = {
  APPROVE: 'APPROVE',
  REJECT: 'REJECT',
  PENDING: 'PENDING',
  FAILURE: 'FAILURE',
  INPROGRESS: 'INPROGRESS',
};

export const ENUM_RESULT_REQUEST_TYPE = {
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  CHECKING_BY: 'CHECKING_BY',
};

export const SUBMIT_SAVANT_RESULT = {
  FAIL: 'FAIL',
  PASS: 'PASS',
};

export const ENUM_PAGE_TYPE = {
  RETURNED_DOCUMENT: 'RETURNED_DOCUMENT',
  SUMMARY: 'SUMMARY',
};

export const REGEX_PATTERN = {
  WHITESPACE: /\s/g,
  AT_LEAST_LOWERCASE: /^(?=.*[a-z]).+/g,
  AT_LEAST_UPPERCASE: /^(?=.*[A-Z]).+/g,
  AT_LEAST_DIGIT: /^(?=.*[0-9]).+/g,
  AT_LEAST_SPECIAL_CHAR: /^(?=.*[!@#$%^&*()]).+/g,
  VALID_TAX_NO: /^[a-zA-Z0-9]+$/,
  VALID_EMAIL:
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
};

export const TOKEN = {
  ACCESS_TOKEN: 'access_token',
  SP_ACCESS_TOKEN: 'sun_portal_access_token',
};

export const COOKIE_NAME = {
  ACTIVE_PROFILE: 'active_profile',
};
